var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg360Dashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_385_3768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.19885e-05C9.98815 2.19885e-05 9.97432 2.19885e-05 9.96247 2.19885e-05C9.9526 2.19885e-05 9.94272 -0.00195312 9.93285 -0.00195312C9.89532 -0.00195312 9.85779 0.0019971 9.82026 0.00397222C4.3887 0.102728 0.00197511 4.54476 0 9.99805V10V10.002C0.00197511 15.4671 4.4124 19.921 9.85977 19.9961C9.88347 19.9961 9.90717 20 9.93087 20C9.9368 20 9.9447 20 9.95062 20C9.96642 20 9.98222 20.002 10 20.002C15.5125 20.002 19.998 15.5165 19.998 10.002C19.998 4.48748 15.5145 2.19885e-05 10 2.19885e-05ZM18.9986 9.50624H15.473C15.3842 6.05572 14.367 3.11478 12.8521 1.45173C16.2769 2.59927 18.7952 5.74958 18.9986 9.50624ZM9.50622 1.02906V9.50624H5.38021C5.50662 5.11952 7.30792 1.45371 9.50622 1.02906ZM9.50622 10.4938V18.969C7.30792 18.5444 5.50662 14.8805 5.38021 10.4938H9.50622ZM10.4938 18.9374V10.4938H14.4835C14.3591 14.7897 12.6309 18.3923 10.4938 18.9374ZM10.4938 9.50624V1.06263C12.6309 1.60974 14.3591 5.21235 14.4835 9.50624H10.4938ZM6.95437 1.51888C5.46909 3.19181 4.47758 6.10115 4.39068 9.50624H1.00138C1.20087 5.82068 3.62828 2.7158 6.95437 1.51888ZM1.00138 10.4938H4.39068C4.47956 13.9009 5.47107 16.8102 6.95635 18.4831C3.62828 17.2842 1.20284 14.1813 1.00138 10.4938ZM12.8501 18.5483C14.367 16.8872 15.3842 13.9463 15.473 10.4938H18.9986C18.7952 14.2524 16.2769 17.4027 12.8501 18.5483Z",
    fill: "#414446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_3768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg360Dashboard);
export default __webpack_public_path__ + "static/media/360 Dashboard.72ef3ec7763757ae9fdbfa9baf962e1a.svg";
export { ForwardRef as ReactComponent };